const advancedTabsWidget = () => {
  document.querySelectorAll('.js-advanced-tabs-widget').forEach((widget) => {
    const tabs = widget.querySelectorAll('.advanced-tabs-widget__tab');
    const tabContent = widget.querySelectorAll('.tab-content');
    const tabsLength = tabs.length;

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        resetTabs();
        tab.classList.add('active');
        tabContent[i].classList.remove('hidden');
      });
    });

    tabContent.forEach((content, i) => {
      const leftArrow = content.querySelector('.arrow-left');
      const rightArrow = content.querySelector('.arrow-right');

      leftArrow.addEventListener('mouseenter', () => hoverPrev(i));
      rightArrow.addEventListener('mouseenter', () => hoverNext(i));

      leftArrow.addEventListener('mouseleave', () => unhoverPrev(i));
      rightArrow.addEventListener('mouseleave', () => unhoverNext(i));

      leftArrow.addEventListener('click', () => prevtab(i));
      rightArrow.addEventListener('click', () => nextTab(i));
    });

    const prevtab = (index) => {
      resetTabs();
      if (index === 0) {
        tabs[tabsLength - 1].classList.add('active');
        tabContent[tabsLength - 1].classList.remove('hidden');
      } else {
        tabs[index - 1].classList.add('active');
        tabContent[index - 1].classList.remove('hidden');
      }
    };
    const nextTab = (index) => {
      resetTabs();
      if (index === tabsLength - 1) {
        tabs[0].classList.add('active');
        tabContent[0].classList.remove('hidden');
      } else {
        tabs[index + 1].classList.add('active');
        tabContent[index + 1].classList.remove('hidden');
      }
    };

    const hoverPrev = (index) => {
      if (index === 0) {
        tabs[tabsLength - 1].classList.add('hover');
      } else {
        tabs[index - 1].classList.add('hover');
      }
    };

    const unhoverPrev = (index) => {
      if (index === 0) {
        tabs[tabsLength - 1].classList.remove('hover');
      } else {
        tabs[index - 1].classList.remove('hover');
      }
    };

    const hoverNext = (index) => {
      if (index === tabsLength - 1) {
        tabs[0].classList.add('hover');
      } else {
        tabs[index + 1].classList.add('hover');
      }
    };

    const unhoverNext = (index) => {
      if (index === tabsLength - 1) {
        tabs[0].classList.remove('hover');
      } else {
        tabs[index + 1].classList.remove('hover');
      }
    };

    const resetTabs = () => {
      tabs.forEach((tab) => tab.classList.remove('active'));
      tabContent.forEach((content) => content.classList.add('hidden'));
    };
  });
};

document.addEventListener('DOMContentLoaded', () => {
  advancedTabsWidget();
});
